export default __webpack_public_path__ + "static/IMG_9216-9e5517b3fcc7f2a83b64dc709ba92837.jpg";